import { render, staticRenderFns } from "./blog-details.html?vue&type=template&id=195fce3a&scoped=true&external"
import script from "./blog-details.js?vue&type=script&lang=js&external"
export * from "./blog-details.js?vue&type=script&lang=js&external"
import style0 from "./blog-details.scss?vue&type=style&index=0&id=195fce3a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195fce3a",
  null
  
)

export default component.exports